import React, { Component } from 'react';
import { FormGroup } from 'reactstrap';
import CustomLoader from './CustomLoader';

export class Comments extends Component {
  displayName = Comments.name

  constructor(props) {
    super(props);

    this.state = {
      comments: [],
      loader: true
    }
  }

  componentDidMount() {
    fetch('api/DataforDB/GetPublishComments')
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then(data => {
      this.setState({ comments: data, loader: false });
    });
  }

  render() {
    return (
      <React.Fragment>
        <CustomLoader visible={this.state.loader}/>
        <div className={this.state.loader ? 'display-none' : ''}>
          <h1>Отзывы</h1>
          <FormGroup>
            <a className='btn btn-primary' href='/addComments'>Оставить отзыв</a>
          </FormGroup>
          {this.state.comments.map(c => {
            return (
            <div key={c.id} className='comment-block'>
              <h6 className='comment-title'>{c.nameAuthor}</h6>
              <FormGroup>
                {c.commentText}
              </FormGroup>
            </div>);
          })}
          {this.state.comments.length === 0 && < FormGroup className='alert alert-primary'>Будьте первым кто оставит отзыв!</FormGroup>}
      </div>
      </React.Fragment>
    );
  }
}
